module.exports = __webpack_public_path__ + "img/gn.279e5b65.png";